import { type AxiosError, type AxiosResponse, type ResponseType } from "axios";
import { privateApi } from "./axiosInterceptor";
import { sessionStatusExpired, sessionStatusParam } from "./types";

export type FetcherError = AxiosError;

export const fetcher = async <T>(
  url: string,
  params?: object,
  responseType?: ResponseType,
): Promise<T> => {
  const res: AxiosResponse<T> = await privateApi.get(url, {
    params,
    responseType,
  });
  return res.data;
};

export class FetchError extends Error {
  constructor(
    message: string,
    public status: number,
  ) {
    super(message);
    this.name = "FetchError";
  }
}

export const simpleFetcher = (url: string, type: "json" | "text" = "json") =>
  fetch(url).then((res) => {
    if (res.ok) return res[type]();
    if (res.status === 401 && window.location.pathname !== "/login") {
      const redirect = encodeURIComponent(window.location.pathname);
      window.location.replace(
        `/login?${sessionStatusParam}=${sessionStatusExpired}&redirect=${redirect}`,
      );
    }
    throw new FetchError("Failed to fetch data", res.status);
  });
